import ModelValidator from '@/validator/Validator';

import ControlValidator from './CustomValidator';

class FormControlValidator {
  public static buildValidator<T = unknown>(validator: ModelValidator, key: string): ControlValidator<T> {
    return (value) => {
      // Clear control errors, warning, succes message before running validation again
      delete validator.messageBag.errors.messages[key];
      delete validator.messageBag.warnings.messages[key];
      delete validator.messageBag.success.messages[key];
      // Run validation for this control only˝
      const rules = validator.getRules()?.[key] ?? '';
      const response = validator.manualValidate(value, rules, key);
      if (!response.messageBag.errors.has(key)) {
        return null;
      }
      const errors: string[] = response.messageBag.errors.get(key);
      const errorsRecord: Record<string, string> = {};
      Object.assign(errorsRecord, errors); // Will return an object like {0: 'first error ', 1: 'second error'}
      return errorsRecord;
    };
  }
}

export default FormControlValidator;
